import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError, take } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import { ReturnOrderService } from "../services/return-order/return-order.service";
import { DeliveryOptionsService, ShippingType } from "../services/delivery-options.service";
import { clientConfig } from "../constant/app.constant";
import { TranslateCacheService } from "../../../translate-cache/translate-cache.service";

@Injectable()
export class ReturnOrderRouteResolver  {
  constructor(
    private returnOrderSerice: ReturnOrderService,
    private store: Store<AppState>,
    private deliveryOptionsService: DeliveryOptionsService,
    private router: Router,
    private translateCacheService: TranslateCacheService
  ) {}

  resolve() {
    let order: any, orderData: any;
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        order = ro;
      });

    this.store
      .pipe(select("orderData"))
      .pipe(take(1))
      .subscribe((o) => {
        orderData = o;
      });

    let deliveryOption;
    let shippingOptionType=this.deliveryOptionsService.getTypeByMode(order.deliveryOption.type);
    if (shippingOptionType === ShippingType.Collection) {
      const deliveryDate = `${order.deliveryOption.date.month}/${order.deliveryOption.date.day}/${order.deliveryOption.date.year}`;

      deliveryOption = {
        ...order.deliveryOption,
        date: deliveryDate,
        shippingOptionType:this.deliveryOptionsService.mapShippingOptionType(shippingOptionType)
      };
    } else {
      // considering only dropOff option

      deliveryOption = {
        type: order.deliveryOption.type,
        labelFormat: order.deliveryOption.labelFormat,
        shippingOptionType:this.deliveryOptionsService.mapShippingOptionType(shippingOptionType)
       };
    }

    if(order && order.deliveryOption && order.deliveryOption.carrier && order.deliveryOption.carrierService)
    {
      deliveryOption.carrier = order.deliveryOption.carrier;
      deliveryOption.carrierService = order.deliveryOption.carrierService;
    }

    let orderLines = [];
    if (order.items && order.items.length) {
      orderLines = order.items.map((item) => {
        return {
          lineNumber: item.lineNumber,
          itemName: item.itemName,
          itemNumber: item.itemNumber,
          returnableQuantity: parseInt(item.returnableQuantity),
          returnQuantity: parseInt(item.returnQuantity),
          returnInstructions: item.returnInstructions,
          returnReason: item.reasonForReturn ? item.reasonForReturn : item.returnReason,  // reasonForReturn - when we are selecting reson manually, returnReason - passing through request json
          brand: item.brand,
          size: item.size,
          color: item.color,
          currency: item.currency,
          description: item.description,
          unitPrice: parseFloat(item.unitPrice),
          weight: parseFloat(item.weight),
          volume: parseFloat(item.volume),
          returnableQuantityUnitOfMeasure: this.deliveryOptionsService.getMappedWeightUnit(item?.returnableQuantityUnitOfMeasure),
          deliveryDate: item.deliveryDate,
          returnable: !!item.returnable,
          selectedForReturn: !!item.selectedForReturn,
          originCode: item.originCode,
          lotNumber: item.lotNumber,
          expirationDate: item.expirationDate,
          serialNumbers: item.serialNumbers,
          expectedSerials: item.expectedSerials,
          height: item.height,
          length: item.length,
          width: item.width,
          heightUnitOfMeasure: item.heightUnitOfMeasure,
          lengthUnitOfMeasure: item.lengthUnitOfMeasure,
          widthUnitOfMeasure: item.widthUnitOfMeasure,
          countryOfOrigin: item.countryOfOrigin,
          hsCode: item.hsCode
        };
      });
    }

    const fillOrder = {
      orderLines: orderLines,
      parcelCount: order.numberOfLabels || Number(this.returnOrderSerice.selectedParcelCount),
      deliveryOption: deliveryOption,
      orderAddress: { ...order.orderAddress },
      returnToAddress: { ...order.returnToAddress },
      orderNumber: order.orderNumber,
      currency: order.currency,
      deductionRate: order.deductionRate,
      referenceField1: order.referenceField1,
      referenceField2: order.referenceField2,
      referenceField3: order.referenceField3,
      referenceField4: order.referenceField4,
      referenceField5: order.referenceField5,
      rmaNumber: order.rmaNumber,
      freeText:order.freeText?order.freeText:null,
      brandInfo:order.brandInfo?order.brandInfo:null,
      legalApproved: orderData.legalApproved?orderData.legalApproved:null,
      termsOfDelivery: order.customs?order.customs.termsOfDelivery:null,
      selectedLanguage: this.translateCacheService.getCachedLanguage() == 'en' ? 'en-GB' : this.translateCacheService.getCachedLanguage()
    };

    const returnOrder = {
      merchantId: orderData.merchantId,
      returnCenterId: orderData.returnCenterId,
      errorUri: orderData.errorUri,
      postBackURL: orderData.postBackURL,
      postBackToken: orderData.postBackToken,

      order: fillOrder,
      merchantConfigInDatabase: clientConfig.MERCHANTCONFIG_IN_DB,
    };

    return this.returnOrderSerice.createReturnOrder(returnOrder).pipe(
      catchError((error) => {
        if (returnOrder.errorUri && returnOrder.errorUri !== "") {
          window.location.href = returnOrder.errorUri;
        }

        this.returnOrderSerice.returnOrderLable = {
          show: true,
          message: "lableNoCreated",
        };

        localStorage.setItem('errorMessage', error.error?error.error:null);

        const screenSize = window.innerWidth;

        if (screenSize > 768) {
          this.router.navigate([`/d/globalerror`]);
        }
        else {
          this.router.navigate([`/m/globalerror`]);
        }
        return throwError(error);
      })
    );
  }
}
